import { useEffect, useState, useRef, useCallback} from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { RouteComponentProps } from "react-router-dom";
import StripeCardDetailsModalWrapper from "../../utils/cardDetailsDialog";
import { Box } from "@mui/system";
import { Button, Grid, TextField, Typography,Select,FormControl,MenuItem,Input} from "@mui/material";
import axios from 'axios';
import { createSeller } from "../../redux/action-creators/sellerAction";
import { GooglePlacesDetail } from "../../redux/action-creators/profileAction";
import ClipLoader from "react-spinners/ClipLoader";
import LeftSidebar from "../../components/sidebars/LeftSidebar";
import RightSidebar from "../../components/sidebars/RightSidebar";
import { ImgTypeArray } from "../../utils/constants";
import { isEmpty } from "../../utils/helper";
import { toast } from "../../utils/toastsMessage";
import { locationPrediction, RoutingLinks } from "../../utils/constants";
import imageCompression from "browser-image-compression";
import { ICreateSellerProfile } from "../../interfaceModules/IUserInterface";
import { createSellerProfileValidationSchema } from "../../utils/validationSchema";

import { UserCommonStyles } from "../../styles/CommonStyles";

import { yupResolver } from "@hookform/resolvers/yup";
import { ActionType } from "../../redux/action-types";
import SocialIconSection from "../../components/sidebars/SocialIconSection";

const CreateSeller = (props: RouteComponentProps) => {
  const { t: translation } = useTranslation();
  const commonStyle = UserCommonStyles();
  const dispatch = useDispatch();
  const [cardNumber, setCardNumber] = useState('');
  const [expiryDate, setExpiryDate] = useState('');
  const [cvc, setCvc] = useState('');
  let userData = localStorage.getItem("userData");
  userData = userData ? JSON.parse(userData) : {};
  const [userInfo] = useState(JSON.parse(JSON.stringify(userData)));
  const [sellerInfo, setSellerInfo] = useState<ICreateSellerProfile>();
  const [enableSaveButton, setEnableSaveButton] = useState(false);
  const [timeOutState, setTimeOutState] = useState(null);
  const [locationPredictions, setLocationPredictions] = useState({
    predictions: locationPrediction.predictions,
  });
  const [taxIdError, setTaxError] = useState<string>("");
  const [zipCodeError, setZipCodeError] = useState<string>("");
  const [dayCodeError, setDayCodeError] = useState<string>("");
  const [monthCodeError, setMonthCodeError] = useState<string>("");
  const [yearCodeError, setYearCodeError] = useState<string>("");
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm<ICreateSellerProfile>({
    resolver: yupResolver(createSellerProfileValidationSchema(translation)),
  });
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);
  const [openDialog, setOpenDialog] = useState(false);
    const [profile_image, setprofile_image] = useState(false);
    const [base64, setBase64] = useState<string>("");
    
  const fileSelectHandler = async (e: any) => {


    if (e.target.files[0] !== undefined)
      for (let i = 0; i < e.target.files.length; i++) {
        if (e.target.files[i].type !== undefined) {
          const imgType = e.target.files[i].type.split("/");
          const MimeTypeArray = ImgTypeArray;
          if (imgType[1] !== undefined) {
            if (MimeTypeArray.includes(imgType[1])) {
              setprofile_image(e.target.files[0].name.split(".")[0]);
              
              //handleChange(sellerInfo.id_proof, "id_proof")
              if (e.target && e.target.files[i]) {

                const img = e.target.files[i];
                // console.log("image",img)
                const options = {
                  maxSizeMB: 1,
                  maxWidthOrHeight: 720,
                  useWebWorker: true,
                };
                try {
                  // console.log("IMAGE",img)
                  const compressImg = await imageCompression(img, options);
                  // console.log("compressImg",compressImg)
                  convertBlobToBase64(compressImg).then((base64String) => {
                    console.log('Base64 String:', base64String);
                    setBase64(base64String.toString())
                  })
                  .catch((error) => {
                    console.error('Error converting Blob to Base64:', error);
                  });
                  //readFile(compressImg, e.target.name);
                } catch (e) {
                  console.error("Error while compressing image : ", e);
                }
                //readFile(img, e.target.name);
                convertBlobToBase64(img).then((base64String) => {
                  console.log('Base64 String:', base64String);
                  setBase64(base64String.toString())
                })
                .catch((error) => {
                  console.error('Error converting Blob to Base64:', error);
                });
              }
            }
            else {
              toast.error(translation("file_not_support_img"));
            }
          }
        }
      }
  };
const [profileFile, setprofileFile] = useState<string[]>();
  //
  const readFile = async (file: Blob, name: string) => {
    /**
     * Create an instance of FileReader
     */
    // console.log("FILESS",file)
    const fileReader = new FileReader();
    fileReader.onloadend = (event) =>
      setprofileFile((prevState) => ({
        ...prevState,
        profileImage: fileReader.result,
      }));
    
    fileReader.readAsDataURL(file);

    /**
     * Start reading the file
     */
  };
  const convertBlobToBase64 = (blob) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader(); 
      reader.onloadend = () => {
        resolve(reader.result);
      };
      reader.onerror = (error) => {
        reject(error);
      };
      reader.readAsDataURL(blob);
    });
  };
  //
  const handleCloseDialog = async (token) => {
    setOpenDialog(false);
    setEnableSaveButton(true);
    if (token) {
      setSellerInfo({
        ...sellerInfo,
        [token]: token,
      });
    const response: any = await dispatch(createSeller(sellerInfo,token,""));
    console.log("SAKKKKK->",response)
    if (response?.data?.isRegistered) {
      setEnableSaveButton(false);
      props.history.push(RoutingLinks.marketplace);
      let userDetails = userInfo;
      userDetails = {
        ...userDetails,
        seller_id: response.sellerId,
      };
      localStorage.setItem("userData", JSON.stringify(userDetails));
      await dispatch({
        type: ActionType.LOGIN,
        payload: JSON.stringify(userDetails),
      });
      //-- Lo
      props.history.push(RoutingLinks.marketplace);
      return toast.success(translation(response.message));
      //
    } else {
      setEnableSaveButton(false);
      // return toast.error(translation(response.message));
      console.log("SAK---->",response)
      if(response?.error != undefined){
        return alert((response?.error?.raw?.message != undefined) ? response?.error?.raw?.message:"Something went wrong");
      }else return toast.error(translation(response.message));
    }
    }else setEnableSaveButton(false);
  };
  /**
   * Updates the Textfield value in the state
   * @param event
   * @param name
   */
  const handleChange = (event: any, name: string) => {
    let target = event.target as HTMLInputElement;
    if (name === "tax_id" && !/^\d+$/.test(target?.value)) {
      return setTaxError("Tax Id is required in Number");
    }
     else {
      setTaxError("");
      setSellerInfo({
        ...sellerInfo,
        [name]: target.value,
      });
    }
  };
  function useOutsideAlerter(ref) {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setLocationPredictions((prevState) => ({
            ...prevState,
            predictions: [],
          }));
        }
      }

      /**
       * Bind the event listener
       */
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        /**
         * Unbind the event listener on clean up
         */
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  /**
   * auto fill seller data
   */
  const autoFillSellerData = useCallback(async () => {
    if (userInfo) {
      setSellerInfo({
        userId: userInfo.id,
        firstname: userInfo.first_name,
        lastname: userInfo.last_name,
        email: userInfo.email,
        phone_number: userInfo.phone_number,
        location: userInfo.address,
        latitude: userInfo.latitude,
        longitude: userInfo.longitude,
        description: userInfo.description,
        image: userInfo.profile_image ? userInfo.profile_image : "",
        tax_id: null,
        imageUpdate: false,
        imageName: userInfo.profile_image
          ? userInfo.profile_image.substring(
              userInfo.profile_image.lastIndexOf("/") + 1
            )
          : "",
      });
    }
  }, [userInfo]);

  let obj = {
    "us_states": [
            "Alabama",
            "Alaska",
            "Arizona",
            "Arkansas",
            "California",
            "Colorado",
            "Connecticut",
            "Delaware",
            "Florida",
            "Georgia",
     ],
     "supported_payment_currencies": [
             "usd",
             "aed",
             "afn",
             "all",
             "amd",
      ],
      "supported_transfer_countries": [
             "US",
             "AG",
              "AL",
              "AM",
      ]
}

  const [countries, setCountries] = useState<Object>(obj);
  const [currency, setCurrency] = useState<Object>("");

  const URLL = process.env.REACT_APP_API_URL;
  useEffect(() => {
    console.log(countries?.supported_transfer_countries)
    const fetchData = async () => {
      try {
        const res: any = await axios.post(
          `${URLL}/api/v1/seller/stripe-countries`
        );
        console.log(res)
       if(res.data?.data != null) setCountries(res.data.data)
      } catch (error) {
        console.log("SAK",error)
        toast.error("Something went wrong")
      }
    };
    fetchData();
  }, []);

  /**
   * Autocomplete in search
   * @param text
   * @returns
   */
  const googleAutocomplete = async (text: string) => {
    if (isEmpty(text)) {
      setLocationPredictions((prevState) => ({
        ...prevState,
        predictions: [],
      }));
      return null;
    }
    if (!text) {
      return translation("valid_text");
    }

    /**
     * for use in things like GatsbyJS where the html is generated first
     */
    if (typeof window === "undefined") {
      return translation("valid_window");
    }

    try {
      let result;
      let autocompleteService =
        await new google.maps.places.AutocompleteService();
      result = await autocompleteService.getPlacePredictions(
        { input: text },
        result
      );
      return result;
    } catch (e) {
      return e;
    }
  };

  /**
   * select location
   * @param event
   */
  const selectLocation = async (event: React.SyntheticEvent | Event) => {
    let target = event.target as HTMLInputElement;
    setSellerInfo((prevState) => ({
      ...prevState,
      location: target.value,
      latitude: 0,
      longitude: 0,
    }));
    if (timeOutState) {
      clearInterval(timeOutState);
    }

    let result = setTimeout(async () => {
      let results = await googleAutocomplete(target.value);
      if (results) {
        setLocationPredictions((prevState) => ({
          ...prevState,
          predictions: results?.predictions,
        }));
      }
    }, 800);

    setTimeOutState(result);
  };

  /**
   * on Place selected by placeId
   * @param placeId
   * @param placeDescription
   * @param event
   * @returns
   */
  const onPlaceSelected = async (
    placeId: string,
    placeDescription: string,
    event: React.SyntheticEvent
  ) => {
    event.preventDefault();
    const response: any = await dispatch(GooglePlacesDetail(placeId));
    if (!response || !response.result) {
      return;
    }
    setSellerInfo((prevState) => ({
      ...prevState,
      location: placeDescription,
      latitude: response.result?.geometry?.location?.lat,
      longitude: response.result?.geometry?.location?.lng,
    }));
    setLocationPredictions({
      predictions: [],
    });
  };

  /**
   * To submit data
   * @returns
   */
  const onSubmit = async () => {
    console.log("sellerInfo :>> ", sellerInfo);
    setTaxError("");
    if (
      sellerInfo?.snn !== undefined && sellerInfo?.snn !== "" &&
      sellerInfo?.address !== undefined && sellerInfo?.address !== "" &&
      sellerInfo?.state !== undefined && sellerInfo?.state !== "" &&
      sellerInfo?.city !== undefined && sellerInfo?.city !== "" &&
      sellerInfo?.country !== undefined && sellerInfo?.country !== "" &&
      sellerInfo?.zip_code !== undefined && sellerInfo?.zip_code !== "" &&
      sellerInfo?.day !== undefined && sellerInfo?.day !== "" &&
      sellerInfo?.month !== undefined && sellerInfo?.month !== "" &&
      sellerInfo?.year !== undefined && sellerInfo?.year !== "" &&
      cardNumber !== "" &&
      expiryDate !== undefined && cvc !== "" && sellerInfo?.currency !== "" && sellerInfo?.currency !== undefined
    ) {
      //
      try {
        // Make the token creation request to your server
        const [expiryMonth, expiryYear] = expiryDate.split('/');
        const response = await axios.post(
          'https://api.stripe.com/v1/tokens',
          new URLSearchParams({
            'card[number]': cardNumber,
            'card[exp_month]': expiryMonth.trim(),
            'card[exp_year]': expiryYear.trim(),
            'card[cvc]': cvc,
            'card[currency]': sellerInfo?.currency,
          }),
          {
            headers: {
              Authorization: `Bearer ${process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || ""}`,
            },
          }
        );
  
        console.log('Token Created:', response.data.id);
       
        return handleCloseDialog(response.data.id); // Contains the token to use later
      } catch (error) {
        
        console.log(JSON.stringify(error));
        if (axios.isAxiosError(error)) {
          if (error.response) {
            // Server responded with a status code outside the 2xx range
            const errorDetails = error.response.data;
            console.error('Stripe Error:', errorDetails);
        
            // Extract meaningful message
            const message = errorDetails.error?.message || 'An error occurred while processing your payment.';
        
            // Show error to user
            alert(message);
          } else alert("Something went wrong");
        } else alert("Something went wrong");
        
      }
      //
    } else {
      setEnableSaveButton(false);
      toast.info("Please fill all required fields!");
    }

    // setTaxError("");
    // setEnableSaveButton(true);
    // const response: any = await dispatch(createSeller({ sellerInfo }));
    // if (response?.data?.isRegistered) {
    //   setEnableSaveButton(false);
    //   props.history.push(RoutingLinks.marketplace);
    //   let userDetails = userInfo;
    //   userDetails = {
    //     ...userDetails,
    //     seller_id: response.sellerId,
    //   };
    //   localStorage.setItem("userData", JSON.stringify(userDetails));
    //   await dispatch({
    //     type: ActionType.LOGIN,
    //     payload: JSON.stringify(userDetails),
    //   });
    //   return toast.success(translation(response.message));
    // } else {
    //   setEnableSaveButton(false);
    // }
  };

  const onSubmitBankAccount = async () => {
    console.log("sellerInfo :>> ", sellerInfo);
    setTaxError("");
    if (
      sellerInfo?.address !== undefined && sellerInfo?.address !== "" &&
      sellerInfo?.currency !== undefined && sellerInfo?.currency !== "" &&
      sellerInfo?.city !== undefined && sellerInfo?.city !== "" &&
      sellerInfo?.country !== undefined && sellerInfo?.country !== "" &&
      sellerInfo?.zip_code !== undefined && sellerInfo?.zip_code !== "" &&
      sellerInfo?.id_number !== undefined && sellerInfo?.id_number !== "" &&
      sellerInfo?.routing_number !== undefined && sellerInfo?.routing_number !== "" &&
      sellerInfo?.account_number !== undefined && sellerInfo?.account_number !== "" 
      && base64 !== "" && base64 !== undefined
    ) {
      //
      try {
        // 
                setEnableSaveButton(true);
            const response: any = await dispatch(createSeller(sellerInfo,"BankAccount",base64));
            console.log("SAKKKKK->",response)
            if (response?.data?.isRegistered) {
              setEnableSaveButton(false);
              props.history.push(RoutingLinks.marketplace);
              let userDetails = userInfo;
              userDetails = {
                ...userDetails,
                seller_id: response.sellerId,
              };
              localStorage.setItem("userData", JSON.stringify(userDetails));
              await dispatch({
                type: ActionType.LOGIN,
                payload: JSON.stringify(userDetails),
              });
              //-- Lo
              props.history.push(RoutingLinks.marketplace);
              return toast.success(translation(response.message));
              //
            } else {
              setEnableSaveButton(false);
              // return toast.error(translation(response.message));
              console.log("SAK---->",response)
              if(response?.error != undefined){
                return alert((response?.error?.raw?.message != undefined) ? response?.error?.raw?.message:"Something went wrong");
              }else return toast.error(translation(response.message));
            } 
        // 
      } catch (error) {
        
        console.log(JSON.stringify(error));
        if (axios.isAxiosError(error)) {
          if (error.response) {
            // Server responded with a status code outside the 2xx range
            const errorDetails = error.response.data;
            console.error('Stripe Error:', errorDetails);
        
            // Extract meaningful message
            const message = errorDetails.error?.message || 'An error occurred while processing your payment.';
        
            // Show error to user
            alert(message);
          } else alert("Something went wrong");
        } else alert("Something went wrong");
        
      }
      //
    } else {
      setEnableSaveButton(false);
      toast.info("Please fill all required fields!");
    }
  };
  useEffect(() => {
    autoFillSellerData();
  }, [autoFillSellerData]);

  return (
    <Box>
      <StripeCardDetailsModalWrapper open={openDialog} onClose={handleCloseDialog} />
      <Grid container>
        <Grid item md={3}>
          <LeftSidebar />
          {/* <SocialIconSection /> */}
        </Grid>

        <Grid item md={6}>
          <Box className={commonStyle.p20}>
            <Typography
              variant="h6"
              className={`${commonStyle.grey} ${commonStyle.mb15} ${commonStyle.fontWeight600}`}
            >
              {translation("create_profile")}
            </Typography>
            <Box className={`${commonStyle.p20} ${commonStyle.card}`}>
              {sellerInfo && Object.keys(sellerInfo).length > 0 && (
                <form onSubmit={handleSubmit(onSubmit)} noValidate>
                  <Grid container spacing={2}>

                    <Grid item md={6}>
                      <Box className={commonStyle.commonInput}>
                        <Typography className={commonStyle.labelCommonInput}>
                          {translation("fname")}
                        </Typography>
                        <TextField
                          {...register("firstname")}
                          variant="outlined"
                          className={commonStyle.w100}
                          onChange={(e) => handleChange(e, "firstname")}
                          inputProps={{ readOnly: true }}
                          value={
                            sellerInfo.firstname ? sellerInfo.firstname : ""
                          }
                        />
                        {errors && errors.firstname && (
                          <span className={commonStyle.errorMsg}>
                            {errors?.firstname?.message}
                          </span>
                        )}
                      </Box>
                    </Grid>

                    <Grid item md={6}>
                      <Box className={commonStyle.commonInput}>
                        <Typography className={commonStyle.labelCommonInput}>
                          {translation("lname")}
                        </Typography>
                        <TextField
                          {...register("lastname")}
                          variant="outlined"
                          className={commonStyle.w100}
                          name="lastname"
                          onChange={(e) => handleChange(e, "lastname")}
                          inputProps={{ readOnly: true }}
                          value={sellerInfo.lastname ? sellerInfo.lastname : ""}
                        />
                        {errors && errors.lastname && (
                          <span className={commonStyle.errorMsg}>
                            {errors?.lastname?.message}
                          </span>
                        )}
                      </Box>
                    </Grid>

                    <Grid item md={12}>
                      <Box className={commonStyle.commonInput}>
                        <Typography className={commonStyle.labelCommonInput}>
                          {translation("location")}
                        </Typography>
                        <TextField
                          {...register("location")}
                          variant="outlined"
                          onChange={selectLocation}
                          autoComplete="off"
                          className={commonStyle.w100}
                          inputProps={{ readOnly: true }}
                          value={sellerInfo.location ? sellerInfo.location : ""}
                        />
                        {locationPredictions.predictions.length !== 0 && (
                          <div className="search-drop-list" ref={wrapperRef}>
                            <ul className={commonStyle.searchCommonList}>
                              {locationPredictions.predictions.map(
                                (prediction) => (
                                  <li
                                    key={prediction?.place_id}
                                    onClick={(e) =>
                                      onPlaceSelected(
                                        prediction?.place_id,
                                        prediction?.description,
                                        e
                                      )
                                    }
                                  >
                                    {prediction?.description ||
                                      translation("not_found")}
                                  </li>
                                )
                              )}
                            </ul>
                          </div>
                        )}

                        {errors && errors.location && (
                          <span className={commonStyle.errorMsg}>
                            {errors?.location?.message}
                          </span>
                        )}
                      </Box>
                    </Grid>

                    <Grid item md={6}>
                      <Box className={commonStyle.commonInput}>
                        <Typography className={commonStyle.labelCommonInput}>
                          {translation("email")}
                        </Typography>
                        <TextField
                          {...register("email")}
                          variant="outlined"
                          className={commonStyle.w100}
                          defaultValue={
                            sellerInfo.email ? sellerInfo.email : ""
                          }
                          inputProps={{ readOnly: true }}
                        />
                        {errors && errors.email && (
                          <span className={commonStyle.errorMsg}>
                            {errors?.email?.message}
                          </span>
                        )}
                      </Box>
                    </Grid>

                    <Grid item md={6}>
                      <Box className={commonStyle.commonInput}>
                        <Typography className={commonStyle.labelCommonInput}>
                          {translation("contact")}
                        </Typography>
                        <TextField
                          {...register("phone_number")}
                          variant="outlined"
                          className={commonStyle.w100}
                          name="phone_number"
                          onChange={(e) => handleChange(e, "phone_number")}
                          value={
                            sellerInfo.phone_number
                              ? sellerInfo.phone_number
                              : ""
                          }
                          inputProps={{ readOnly: true, maxLength: 10 }}
                        />
                        {errors && errors.phone_number && (
                          <span className={commonStyle.errorMsg}>
                            {errors?.phone_number?.message}
                          </span>
                        )}
                      </Box>
                    </Grid>

                    <Grid item md={6}>
                      <Box className={commonStyle.commonInput}>
                        <Typography className={commonStyle.labelCommonInput}>
                          {translation("tax_id")}
                          {" (Optional)"}
                        </Typography>
                        <TextField
                          {...register("tax_id")}
                          variant="outlined"
                          className={commonStyle.w100}
                          // type="number"
                          onChange={(e) => handleChange(e, "tax_id")}
                          inputProps={{
                            min: 0,
                            maxLength: 12,
                          }}
                          value={sellerInfo.tax_id ? sellerInfo.tax_id : ""}
                        />
                        <div style={{ height: "25px" }}>
                          {taxIdError?.length ? (
                            <span className={commonStyle.errorMsg}>
                              {taxIdError}
                            </span>
                          ) : (
                            errors.tax_id && (
                              <span className={commonStyle.errorMsg}>
                                {errors?.tax_id?.message}
                              </span>
                            )
                          )}
                        </div>
                      </Box>
                    </Grid>

                    <Grid item md={6}>
                      <Box className={commonStyle.commonInput}>
                        <Typography className={commonStyle.labelCommonInput}>
                          {translation("profile_photo")}
                        </Typography>
                        <Box className={commonStyle.uploadBoxOutline}>
                          <Typography
                            className={`${commonStyle.flexCenter} ${commonStyle.h100} ${commonStyle.px15}`}
                          >
                            {sellerInfo.imageName}
                          </Typography>
                        </Box>
                      </Box>
                    </Grid>

                    <Grid item md={12}>
                      <Box className={commonStyle.commonInput}>
                        <Typography className={commonStyle.labelCommonInput}>
                          {translation("bio")}
                        </Typography>
                        <TextField
                          {...register("description")}
                          multiline
                          variant="outlined"
                          className={commonStyle.w100}
                          name="description"
                          inputProps={{ readOnly: true }}
                          onChange={(e) => handleChange(e, "description")}
                          rows={5}
                          value={
                            sellerInfo.description ? sellerInfo.description : ""
                          }
                        />
                        {errors && errors.description && (
                          <span className={commonStyle.errorMsg}>
                            {errors?.description?.message}
                          </span>
                        )}
                      </Box>
                    </Grid>
                     {/* Address Section */}
  
                  <Grid item md={12}>
                    <Box className={commonStyle.commonInput}>
                      <Typography className={commonStyle.labelCommonInput}>
                        {translation("address")}
                      </Typography>
                      <TextField
                        {...register("address")}
                        variant="outlined"
                        className={commonStyle.w100}
                        onChange={(e) => handleChange(e, "address")}
                        value={sellerInfo.address ? sellerInfo.address : ""}
                      />
                      {errors && errors.address && (
                        <span className={commonStyle.errorMsg}>
                          {errors?.address?.message}
                        </span>
                      )}
                    </Box>
                  </Grid>
     {/* Country */}
     <Grid item  md={6}>
                  <Typography
                    mb={0.5}
                    variant="h6"
                    className={`${commonStyle.tundora} ${commonStyle.fontWeight400} ${commonStyle.f_family_Roboto} ${commonStyle.font14}`}
                  >
                    {translation("country")}
                  </Typography>
                  <FormControl
                    sx={{
                      m: 0,
                      minWidth: 120,
                      width: "100%",
                      borderRadius: "4px",
                    }}
                  >
                    <Select
                      placeholder="Countries"
                      style={{
                        width: "100%",
                        height: 56,
                        borderWidth: 1,
                        borderColor: "#949494",
                      }}
                      onChange={(e) =>{
                        console.log("SAK-->",e.target)
                         handleChange(e, "country")
                        }}
                      value={sellerInfo.country ? sellerInfo.country : ""}
                      
                      // onChange={handleChange_Dropdown}
                      inputProps={{ "aria-label": "Without label" }}
                    >
                      {countries?.supported_transfer_countries?.map((item: any) => {
                        console.log(item)
                        return (
                          <MenuItem value={item?.code}>{item?.name}</MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                  {/* {step2ValidationErrors &&
                    step2ValidationErrors.budgetValueError && (
                      <span className={commonStyle.errorMsg}>
                        {step2ValidationErrors.budgetValueError}
                      </span>
                    )} */}
                </Grid>
  {/* Country */}
    {/* Currency */}
    <Grid item  md={6}>
                  <Typography
                    mb={0.5}
                    variant="h6"
                    className={`${commonStyle.tundora} ${commonStyle.fontWeight400} ${commonStyle.f_family_Roboto} ${commonStyle.font14}`}
                  >
                    {translation("Currency")}
                  </Typography>
                  <FormControl
                    sx={{
                      m: 0,
                      minWidth: 120,
                      width: "100%",
                      borderRadius: "4px",
                    }}
                  >
                    <Select
                      placeholder="Currencies"
                      style={{
                        width: "100%",
                        height: 56,
                        borderWidth: 1,
                        borderColor: "#949494",
                      }}
                      onChange={(e) =>{
                        console.log("SAK-->",e.target.value)
                         handleChange(e, "currency")
                        }}
                      value={sellerInfo.currency ? sellerInfo.currency : ""}
                      
                      // onChange={handleChange_Dropdown}
                      inputProps={{ "aria-label": "Without label" }}
                    >
                      {countries?.supported_payment_currencies?.map((item: any) => {
                        return (
                          <MenuItem value={item}>{item}</MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                  {/* {step2ValidationErrors &&
                    step2ValidationErrors.budgetValueError && (
                      <span className={commonStyle.errorMsg}>
                        {step2ValidationErrors.budgetValueError}
                      </span>
                    )} */}
                </Grid>
  {/* Currency */}
                  <Grid item md={6}>
                    <Box className={commonStyle.commonInput}>
                      <Typography className={commonStyle.labelCommonInput}>
                        {translation("city")}
                      </Typography>
                      <TextField
                        {...register("city")}
                        variant="outlined"
                        className={commonStyle.w100}
                        onChange={(e) => handleChange(e, "city")}
                        value={sellerInfo.city ? sellerInfo.city : ""}
                      />
                      {errors && errors.city && (
                        <span className={commonStyle.errorMsg}>
                          {errors?.city?.message}
                        </span>
                      )}
                    </Box>
                  </Grid>

      {/* State */}
   {sellerInfo.country == "US" &&   <Grid item  md={6}>
                  <Typography
                    mb={0.5}
                    variant="h6"
                    className={`${commonStyle.tundora} ${commonStyle.fontWeight400} ${commonStyle.f_family_Roboto} ${commonStyle.font14}`}
                  >
                    {translation("State")}
                  </Typography>
                  <FormControl
                    sx={{
                      m: 0,
                      minWidth: 120,
                      width: "100%",
                      borderRadius: "4px",
                    }}
                  >
                    <Select
                      placeholder="States"
                      style={{
                        width: "100%",
                        height: 56,
                        borderWidth: 1,
                        borderColor: "#949494",
                      }}
                      onChange={(e) => handleChange(e, "state")}
                      value={sellerInfo.state ? sellerInfo.state : ""}
                      
                      // onChange={handleChange_Dropdown}
                      inputProps={{ "aria-label": "Without label" }}
                    >
                      {countries?.us_states?.map((item: any) => {
                        return (
                          <MenuItem value={item}>{item}</MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                  {/* {step2ValidationErrors &&
                    step2ValidationErrors.budgetValueError && (
                      <span className={commonStyle.errorMsg}>
                        {step2ValidationErrors.budgetValueError}
                      </span>
                    )} */}
                </Grid>
              }
  {/* State */}
                  {/* <Grid item md={6}>
                    <Box className={commonStyle.commonInput}>
                      <Typography className={commonStyle.labelCommonInput}>
                        {translation("state")+"*"}
                      </Typography>
                      <TextField
                        {...register("state")}
                        variant="outlined"
                        className={commonStyle.w100}
                        onChange={(e) => handleChange(e, "state")}
                        value={sellerInfo.state ? sellerInfo.state : ""}
                      />
                      {errors && errors.state && (
                        <span className={commonStyle.errorMsg}>
                          {errors?.state?.message}
                        </span>
                      )}
                    </Box>
                  </Grid> */}
  
                  <Grid item md={6}>
                    <Box className={commonStyle.commonInput}>
                      <Typography className={commonStyle.labelCommonInput}>
                        {translation("zip_code")}
                      </Typography>
                      <TextField
                        {...register("zip_code")}
                        variant="outlined"
                        className={commonStyle.w100}
                        type="number"
                        onChange={(e) => handleChange(e, "zip_code")}
                        value={sellerInfo.zip_code ? sellerInfo.zip_code : ""}
                      />
                      {errors && errors.zip_code && (
                        <span className={commonStyle.errorMsg}>
                          {errors?.zip_code?.message}
                        </span>
                      )}
                    </Box>
                  </Grid>
                  {/* <Grid item md={6}>
                    <Box className={commonStyle.commonInput}>
                      <Typography className={commonStyle.labelCommonInput}>
                        {translation("country")+"*"}
                      </Typography>
                      <TextField
                        {...register("country")}
                        variant="outlined"
                        className={commonStyle.w100}
                        onChange={(e) => handleChange(e, "country")}
                        value={sellerInfo.country ? sellerInfo.country : ""}
                      />
                      {errors && errors.country && (
                        <span className={commonStyle.errorMsg}>
                          {errors?.country?.message}
                        </span>
                      )}
                    </Box>
                  </Grid> */}

                {sellerInfo.country == "US" &&  <Grid item md={6}>
                    <Box className={commonStyle.commonInput}>
                      <Typography className={commonStyle.labelCommonInput}>
                        {translation("SSN(last 4 Digits)")}
                      </Typography>
                      <TextField
                        {...register("snn")}
                        variant="outlined"
                        className={commonStyle.w100}
                        onChange={(e) => {
                          const value = e.target.value;
                          // Allow only numeric values and limit length to 4
                          if (/^\d*$/.test(value) && value.length <= 4) {
                            handleChange(e, "snn");
                          }
                        }}
                        value={sellerInfo.snn || ""}
                      />
                      {errors && errors.country && (
                        <span className={commonStyle.errorMsg}>
                          {errors?.country?.message}
                        </span>
                      )}
                    </Box>
                  </Grid>}
   {/* Address Section */}
                  {/* Date of Birth Section */}
                  <Grid item md={12}>
                  <Typography
              variant="h6"
              className={commonStyle.labelCommonInput}
            >
              {translation("dob")+""}
            </Typography>
                  </Grid>
  
                  <Grid item md={4}>
                    <Box className={commonStyle.commonInput}>
                      <Typography className={commonStyle.labelCommonInput}>
                        {translation("month")}
                      </Typography>
                      <TextField
                        {...register("month")}
                        variant="outlined"
                        type="number"
                        className={commonStyle.w100}
                        onChange={(e) => handleChange(e, "month")}
                        value={sellerInfo.month ? sellerInfo.month : ""}
                      />
                      {errors && errors.month && (
                        <span className={commonStyle.errorMsg}>
                          {errors?.month?.message}
                        </span>
                      )}
                    </Box>
                  </Grid>

                  <Grid item md={4}>
                    <Box className={commonStyle.commonInput}>
                      <Typography className={commonStyle.labelCommonInput}>
                        {translation("day")}
                      </Typography>
                      <TextField
                        {...register("day")}
                        variant="outlined"
                        type="number"
                        className={commonStyle.w100}
                        onChange={(e) => handleChange(e, "day")}
                        value={sellerInfo.day ? sellerInfo.day : ""}
                      />
                      {errors && errors.day && (
                        <span className={commonStyle.errorMsg}>
                          {errors?.day?.message}
                        </span>
                      )}
                    </Box>
                  </Grid>
  
                  <Grid item md={4}>
                    <Box className={commonStyle.commonInput}>
                      <Typography className={commonStyle.labelCommonInput}>
                        {translation("year")}
                      </Typography>
                      <TextField
                        {...register("year")}
                        variant="outlined"
                        type="number"
                        className={commonStyle.w100}
                        onChange={(e) => handleChange(e, "year")}
                        value={sellerInfo.year ? sellerInfo.year : ""}
                      />
                      {errors && errors.year && (
                        <span className={commonStyle.errorMsg}>
                          {errors?.year?.message}
                        </span>
                      )}
                    </Box>
                  </Grid>
                  {/* if not us */}
                  
                  {/* if not us */}
                 {/* Date of Birth Section */}
                 {(sellerInfo.country != "US" && sellerInfo.country != undefined) && <>
                  <Grid item md={12}>
                  <Typography
              variant="h6"
              className={commonStyle.labelCommonInput}
            >
              {translation("Bank Details")}
            </Typography>
                  </Grid>
                 <Grid item md={6}>
                    <Box className={commonStyle.commonInput}>
                      <Typography className={commonStyle.labelCommonInput}>
                        {translation("Id Number (National ID, CNIC, SNIC)")}
                      </Typography>
                      <TextField
                        {...register("id_number")}
                        variant="outlined"
                        className={commonStyle.w100}
                        onChange={(e) => handleChange(e, "id_number")}
                        value={sellerInfo.id_number ? sellerInfo.id_number : ""}
                      />
                      {errors && errors.id_number && (
                        <span className={commonStyle.errorMsg}>
                          {errors?.id_number?.message}
                        </span>
                      )}
                    </Box>
                  </Grid>
                  <Grid item md={6}>
                    <Box className={commonStyle.commonInput}>
                      <Typography className={commonStyle.labelCommonInput}>
                        {translation("Routing number OR Swift/BIC code")}
                      </Typography>
                      <TextField
                        {...register("routing_number")}
                        variant="outlined"
                        className={commonStyle.w100}
                        onChange={(e) => handleChange(e, "routing_number")}
                        value={sellerInfo.routing_number ? sellerInfo.routing_number : ""}
                      />
                      {errors && errors.routing_number && (
                        <span className={commonStyle.errorMsg}>
                          {errors?.routing_number?.message}
                        </span>
                      )}
                    </Box>
                  </Grid>
                  <Grid item md={6}>
                    <Box className={commonStyle.commonInput}>
                      <Typography className={commonStyle.labelCommonInput}>
                        {translation("IBAN Number")}
                      </Typography>
                      <TextField
                        {...register("account_number")}
                        variant="outlined"
                        className={commonStyle.w100}
                        onChange={(e) => handleChange(e, "account_number")}
                        value={sellerInfo.account_number ? sellerInfo.account_number : ""}
                      />
                      {errors && errors.account_number && (
                        <span className={commonStyle.errorMsg}>
                          {errors?.account_number?.message}
                        </span>
                      )}
                    </Box>
                  </Grid>
                  <Grid item md={12}>
                <Box className={commonStyle.commonInput}>
                      <Typography className={commonStyle.labelCommonInput}>
                        {translation("Id Proof")}
                      </Typography>
                      <Box className={commonStyle.uploadBoxOutline}>
                        <Box className={commonStyle.uploadBtn}>
                          <Input
                            type="file"
                            inputProps={{
                              accept: "image/*",
                            }}
                            onChange={fileSelectHandler}
                            name="profile_image"
                          />
                          <Typography>{translation("browse")}</Typography>
                        </Box>
                        <Typography
                          className={`${commonStyle.flexCenter} ${commonStyle.h100} ${commonStyle.px15}`}
                        >
                          {profile_image}
                        </Typography>
                      </Box>
                      {/* <span className={commonStyle.errorMsg}>Please choose file</span> */}
                    </Box>
                  </Grid>
                 </>}
                 {sellerInfo.country == "US" && <>
                 <Grid item md={12}>
                  <Typography
              variant="h6"
              className={commonStyle.labelCommonInput}
            >
              {translation("Card Details")}
            </Typography>
                  </Grid>
  
                  <Grid item md={12}>
                    <Box className={commonStyle.commonInput}>
                      <Typography className={commonStyle.labelCommonInput}>
                        {translation("Card Number")}
                      </Typography>
                      <TextField
                        variant="outlined"
                        className={commonStyle.w100}
                        onChange={(e) => setCardNumber(e.target.value)}
                        value={cardNumber ? cardNumber : ""}
                        inputProps={{ maxLength: 16 }}
                      />
                    </Box>
                  </Grid>
  
                  <Grid item md={6}>
                    <Box className={commonStyle.commonInput}>
                      <Typography className={commonStyle.labelCommonInput}>
                        {translation("Exp Date(MM/YY)")+""}
                      </Typography>
                      <TextField
                        variant="outlined"
                        className={commonStyle.w100}
                        onChange={(e) => setExpiryDate(e.target.value)}
                        value={expiryDate ? expiryDate : ""}
                      />
                    </Box>
                  </Grid>
  
                  <Grid item md={6}>
                    <Box className={commonStyle.commonInput}>
                      <Typography className={commonStyle.labelCommonInput}>
                        {translation("CVV")+""}
                      </Typography>
                      <TextField
                       
                        variant="outlined"
                        className={commonStyle.w100}
                        onChange={(e) => setCvc(e.target.value)}
                        value={cvc ? cvc : ""}
                      />
                    </Box>
                  </Grid></>}
                 {/* Date of Birth Section */}
                 
</Grid>
                  <Box className={commonStyle.flexCenter}>
                    <Box
                      className={`${commonStyle.mr10} ${commonStyle.blueBtn}`}
                    >
                      {/* <CommonButton label="Save & Continue" /> */}
                      <Button
                        disabled={enableSaveButton}
                        onClick={()=>{
                          console.log("Here")
                          if(sellerInfo.country == "US"){
                            // handleSubmit(onSubmit)
                            onSubmit()
                            console.log("Here")
                          }else{
                            onSubmitBankAccount()
                            console.log("BankAccount")
                          }
                        }}
                      >
                        {translation("save")} {enableSaveButton ? <ClipLoader /> : null} 
                      </Button>
                    </Box>
                    <Box
                      className={`${commonStyle.mr10} ${commonStyle.greyBtn}`}
                    >
                      {/* <CommonButton label="Cancel" /> */}
                      <Button onClick={autoFillSellerData}>
                        {translation("cancel")}
                      </Button>
                    </Box>
                  </Box>
                </form>
              )}
            </Box>
          </Box>
        </Grid>
        <Grid item md={3}>
          <RightSidebar />
        </Grid>
      </Grid>
    </Box>
  );
};

export default CreateSeller;
